import {useEffect, useState, useContext} from "react";
import './bus.css';
import { PaymentContext } from "../Payments/PaymentContext";
import { useNavigate } from "react-router";
import {Button, Typography} from '@mui/material';

export default function BookBuses(){
    const [dataObtained, setDataObtained] = useState([]);
    const [date, setDate] = useState(new Date());
    const { setPrice, setSurcharge } = useContext(PaymentContext);
    const [loader, setLoader] = useState(true);
    const navigate = useNavigate();
    useEffect(()=>{
        window.scrollTo(0, 0);
        const url = 'https://mocki.io/v1/8449b383-8e55-4860-a139-9ecba002bd5b';
        fetch(url)
    .then((res)=>{
        res.json()
        .then((data)=>{
            setDataObtained(data);
            setLoader(false);
        })
    })
    } , [])
    return (
       <>
        {loader ? <>
        <div className="loader">
            <img src="/loader.gif" style={{width:'100px', height:'100px'}}/>
        </div>
        </> : <>
        <h3 style={{marginLeft: '16vw'}}>Available Bus Tickets</h3>
        <div className="ticket-container">
            {dataObtained.map((el, idx)=>{
                return (
                    <div className="tkt-box4" key={idx}>
                        <table>
                            <tr>
                                <td>FROM</td>
                                <td>DEPARTURE</td>
                                <td>PRICE</td>
                            </tr>
                            <tr>
                                <td><Typography
                                variant="h4"
                                sx={{lineHeight:'1'}}
                                >{el.from}</Typography></td>
                                <td><h4>{el.departure.departureTime}|{date.getDate()}-{date.getMonth()}-{date.getFullYear()}</h4></td>
                                <td>{el.price}</td>
                            </tr>
                            <tr>
                                <td>To</td>
                                <td>TRAVELLER SERVICES</td>
                                <td>KILOMETERS</td>
                            </tr>
                            <tr>
                                <td><Typography
                                variant="h4"
                                sx={{lineHeight:'1'}}
                                >{el.to}</Typography></td>
                                <td><h4>{el.airlineName}</h4></td>
                                <td>{el.kilometers ? el.kilometers: "N/A"}</td>
                            </tr>
                            <tr>
                                <td>Duration:</td>
                            </tr>
                            <tr>
                                <td><h4>{el.duration}</h4></td>
                            </tr>
                        </table>
                        <Button 
                        variant="contained"
                        sx={{float:'right', marginRight:'20px', marginBottom:'20px'}} 
                        id={el.price} 
                        onClick={(e)=>{
                            e.persist();
                            setPrice(parseInt(e.currentTarget.id));
                            setSurcharge(parseInt(e.currentTarget.id)*0.25);
                            navigate('/payments');
                        }
                        }>BOOK</Button>
                    </div>
                )
            })}
        </div>
        </>}
       </> 
    )
}